(function() {
  var attempts = 0;
  function getGlobals() {
    var el = document.querySelector('[data-strata-stock-data]');
    if (el) {
      try {
        var sRaw = el.getAttribute('data-stocks-json') || el.getAttribute('data-stocks') || '[]';
        var iRaw = el.getAttribute('data-ids-json') || el.getAttribute('data-ids') || '[]';
        var s = JSON.parse(sRaw);
        var i = JSON.parse(iRaw);
        if (!Array.isArray(s)) s = [s];
        if (!Array.isArray(i)) i = [i];
        return { stocks: s, ids: i };
      } catch (e) {}
    }
    return { stocks: window.STRATA_STOCK || [], ids: window.STRATA_STOCK_IDS || [] };
  }
  function renderStock() {
    if (document.querySelector('[data-strata-stock]')) return;
    attempts++;
    var variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) return;
    var variantId = variantInput.value;
    if (!variantId) return;
    var g = getGlobals();
    var idx = g.ids.indexOf(Number(variantId));
    if (idx < 0 || g.stocks[idx] === undefined || g.stocks[idx] === null) return;
    var stock = g.stocks[idx];
    var btn = document.querySelector('[id*="__add-to-cart"]');
    if (!btn) return;
    var wrap = btn.closest('form') || btn.parentElement;
    if (!wrap) return;
    var el = document.createElement('div');
    el.setAttribute('data-strata-stock', '');
    el.style.cssText = 'display:flex;align-items:center;gap:8px;margin:0 0 14px;padding:10px 14px;border:1px solid #d9e8d3;border-radius:8px;background:#f2faf0;font-size:13px;font-weight:600;color:#1e6b2e;';
    el.textContent = stock > 0 ? ('In stock: ' + stock + ' vials left') : 'Currently out of stock - message us on WhatsApp to reserve';
    try {
      wrap.parentElement.insertBefore(el, wrap);
    } catch (e) {
      btn.insertAdjacentElement('beforebegin', el);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderStock);
  } else {
    renderStock();
  }
  var mo = new MutationObserver(renderStock);
  mo.observe(document.body, {childList: true, subtree: true});
  var timer = setInterval(function() {
    if (document.querySelector('[data-strata-stock]') || attempts > 60) { clearInterval(timer); return; }
    renderStock();
  }, 500);
})();
